import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <div>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className=" lg:pl-[116px] mx-auto py-5">
        <div className=" px-5 sm:px-7">
          <div className="flex gap-5 items-center">
            <button
              className="lg:hidden bg-white hover:bg-primary-light h-10 w-10 flex items-center justify-center rounded-full min-h-10 min-w-10 duration-500 ease-in-out transition-all cursor-pointer"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              <Menu size={20} />
            </button>
            <Header />
          </div>
          <main className="mt-8">{children}</main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
